import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { getFeatureFlagValue } from 'store/session/selectors';

import WorkflowsPage from './WorkflowsPage';
// TODO: lazy load
import { initSaga as workStepsListInitSaga } from './data/sagas';

const isWorkflowsAvailable = (state) =>
  getFeatureFlagValue(state, featureFlagKeys.isWorkflowsAvailable);

export default [
  {
    exact: true,
    path: '/processes/workflows',
    helpId: 'workflows_list',
    component: WorkflowsPage,
    permissions: [isWorkflowsAvailable], // TODO: workflows feature flag
    saga: workStepsListInitSaga,
  },
];
